// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const RUN_BENCHLING_BOLTZGEN_STEP_SHAPES = [
  {
    stepType: PipelineStepType.RUN_BENCHLING_BOLTZGEN,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {},
    outputDataShapes: {
      designMetrics: {
        systemName: 'designMetrics',
        displayName: 'Design metrics',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      rawOutput: {
        systemName: 'rawOutput',
        displayName: 'Raw output',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: true
      },
      bestStructure: {
        systemName: 'bestStructure',
        displayName: 'Best-ranked structure',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      targetId: {
        kind: 'domain',
        required: true,
        types: [
          'AA_SEQUENCE'
        ]
      },
      predictionBatchFolderId: {
        kind: 'domain',
        required: true,
        types: [
          'FOLDER'
        ]
      },
      predictionBatchName: {
        kind: 'string',
        required: false
      },
      boltzGenConfig: {
        kind: 'taggedUnion',
        required: true,
        tagKey: 'protocol',
        choices: [
          {
            kind: 'shape',
            required: true,
            fields: {
              protocol: {
                kind: 'string',
                required: true,
                value: 'antibody-anything'
              },
              numDesigns: {
                kind: 'integer',
                required: true,
                minValue: 1,
                maxValue: 100
              },
              scaffolds: {
                kind: 'array',
                required: true,
                elementSpec: {
                  kind: 'enum',
                  required: true,
                  choices: [
                    {
                      value: 'adalimumab_6cr1',
                      displayName: 'Adalimumab (PDB: 6CR1)'
                    },
                    {
                      value: 'belimumab_5y9k',
                      displayName: 'Belimumab (PDB: 5Y9K)'
                    },
                    {
                      value: 'crenezumab_5vzy',
                      displayName: 'Crenezumab (PDB: 5VZY)'
                    },
                    {
                      value: 'dupilumab_6wgb',
                      displayName: 'Dupilumab (PDB: 6WGB)'
                    },
                    {
                      value: 'golimumab_5yoy',
                      displayName: 'Golimumab (PDB: 5YOY)'
                    },
                    {
                      value: 'guselkumab_4m6m',
                      displayName: 'Guselkumab (PDB: 4M6M)'
                    },
                    {
                      value: 'mab1_3h42',
                      displayName: 'Mab1 (PDB: 3H42)'
                    },
                    {
                      value: 'necitumumab_6b3s',
                      displayName: 'Necitumumab (PDB: 6B3S)'
                    },
                    {
                      value: 'nirsevimab_5udc',
                      displayName: 'Nirsevimab (PDB: 5UDC)'
                    },
                    {
                      value: 'sarilumab_8iow',
                      displayName: 'Sarilumab (PDB: 8IOW)'
                    },
                    {
                      value: 'secukinumab_6wio',
                      displayName: 'Secukinumab (PDB: 6WIO)'
                    },
                    {
                      value: 'tezepelumab_5j13',
                      displayName: 'Tezepelumab (PDB: 5J13)'
                    },
                    {
                      value: 'tralokinumab_5l6y',
                      displayName: 'Tralokinumab (PDB: 5L6Y)'
                    },
                    {
                      value: 'ustekinumab_3hmw',
                      displayName: 'Ustekinumab (PDB: 3HMW)'
                    }
                  ]
                },
                minItems: 1
              },
              bindingResidues: {
                kind: 'string',
                required: false
              },
              notBindingResidues: {
                kind: 'string',
                required: false
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              protocol: {
                kind: 'string',
                required: true,
                value: 'protein-anything'
              },
              numDesigns: {
                kind: 'integer',
                required: true,
                minValue: 1,
                maxValue: 100
              },
              minLength: {
                kind: 'integer',
                required: true,
                minValue: 1
              },
              maxLength: {
                kind: 'integer',
                required: true,
                minValue: 1,
                maxValue: 1000
              },
              bindingResidues: {
                kind: 'string',
                required: false
              },
              notBindingResidues: {
                kind: 'string',
                required: false
              }
            }
          }
        ]
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
